import React from 'react';
import Navbar from '../Homepage/Navbar';

function Feedback() {
    return <div>
        <Navbar />
        <div className='p-12'>
            <div className='flex justify-between p-4 border-4'>
                <h1 >FEEDBACK</h1>
                <p >
                    Selected Course
                    <span className='bg-[#5CC9FF] p-2 ml-2'>
                        WEB 3.0
                    </span>
                </p>
            </div>
            <div className='bg-[#5CC9FF80] flex flex-col p-4'>
                <div className='flex justify-between p-8'>
                    <h1 className='text-xl'> Teaching Skill</h1>
                    <div className='flex'>
                        <input type="number" className='bg-[#5CC9FF] w-12' />
                        <p>/5.0</p>
                    </div>
                </div>
                <div className='flex justify-between p-8'>
                    <h1 className='text-xl'> APPROCHABILITY</h1>
                    <div className='flex'>
                        <input type="number" className='bg-[#5CC9FF] w-12' />
                        <p>/5.0</p>
                    </div>
                </div>
                <div className='flex justify-between p-8'>
                    <h1 className='text-xl'> ASSIGNMENTS</h1>
                    <div className='flex'>
                        <input type="number" className='bg-[#5CC9FF] w-12' />
                        <p>/5.0</p>
                    </div>
                </div>
                <div className='flex gap-4 p-8'>
                    <h1 className='text-xl'> PUT YOUR WORD HERE</h1>
                    <div className='flex'>
                        <input type="text" className='bg-[#5CC9FF] w-[20vw]' />

                    </div>
                </div>
                <button className='bg-[#1A3168] p-4 rounded-[1rem] text-white w-[20vw] ml-[40vw] '>
                    submit
                </button>
            </div>
        </div>
    </div>;
}

export default Feedback;
